export default __webpack_public_path__ + "static/media/eg.4b6f132c.jpg";